import axiosClient from './axiosClient';
import { Notification } from '../types'; // Assuming Notification type is defined in types.ts

// --- Notification API Calls ---

export const createNotificationApi = async (notificationData: Omit<Notification, "id">): Promise<Notification> => {
  const response = await axiosClient.post('/notifications', notificationData);
  return response.data;
};

export const fetchUserNotificationsApi = async (uid: string): Promise<Notification[]> => {
  const response = await axiosClient.get(`/users/${uid}/notifications`);
  return response.data;
};

export const markNotificationAsReadApi = async (notificationId: string): Promise<void> => {
  await axiosClient.put(`/notifications/${notificationId}/read`);
};

export const deleteNotificationApi = async (notificationId: string): Promise<void> => {
  await axiosClient.delete(`/notifications/${notificationId}`);
};
